export default function ContactSection() {
  return (
    <section id="contact" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">联系我们</span>
          <h2 className="mt-2 text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            联系我们
          </h2>
          <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
            如果您有内容推荐、平台入驻或合作咨询需求，欢迎通过以下方式与我们取得联系。芭乐视频期待与更多特色视频平台携手，为观众提供更丰富的观影选择。
          </p>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-5">
            <div className="p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <h3 className="mt-4 text-sm font-semibold text-foreground-900">商务合作</h3>
              <p className="mt-1 text-xs text-foreground-500">biz@balevideo.com</p>
            </div>
            <div className="p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto">
                <i className="ri-chat-3-line text-xl text-accent-600"></i>
              </div>
              <h3 className="mt-4 text-sm font-semibold text-foreground-900">内容投稿</h3>
              <p className="mt-1 text-xs text-foreground-500">submit@balevideo.com</p>
            </div>
            <div className="p-6 rounded-xl bg-background-50 border border-background-200/70 text-center">
              <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center mx-auto">
                <i className="ri-customer-service-2-line text-xl text-secondary-600"></i>
              </div>
              <h3 className="mt-4 text-sm font-semibold text-foreground-900">平台入驻</h3>
              <p className="mt-1 text-xs text-foreground-500">join@balevideo.com</p>
            </div>
          </div>

          <a
            href="mailto:contact@balevideo.com"
            className="inline-flex items-center gap-2 mt-8 px-8 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-send-plane-line"></i>
            发送邮件咨询
          </a>
        </div>
      </div>
    </section>
  );
}